import Default from './Default/Disclaimer';
import AonDisclaimer from './AonDisclaimer/Disclaimer';
import IProfileDisclaimer from './IProfileDisclaimer/Disclaimer';
import MarshDisclaimer from './MarshDisclaimer/Disclaimer';

export default { Default, AonDisclaimer, IProfileDisclaimer, MarshDisclaimer };
